import React from 'react';
import { Grid, Box, Typography, Button, IconButton, Tooltip } from '@material-ui/core';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import ClearIcon from '@material-ui/icons/Clear';

/**
 * @description Componente reutilizable para carga de archivos PDF.
 * @param {Object} props - Propiedades del componente
 * @param {string} props.fileName - Nombre del archivo seleccionado
 * @param {Function} props.onChange - Función callback cuando se selecciona un archivo
 * @param {Function} props.onClear - Función callback para limpiar el archivo seleccionado
 * @param {string} props.label - Texto placeholder cuando no hay archivo seleccionado
 * @param {string} props.inputId - ID único para el input file (requerido para múltiples instancias)
 */
const FileUpload = ({ fileName, onChange, onClear, label = 'Archivo comprobante', inputId = 'file-upload-button' }) => {
    return (
        <Grid container style={{ marginTop: '24px' }}>
            <Grid item xs={12}>
                <Box
                    style={{
                        border: '1px solid rgba(0, 0, 0, 0.23)',
                        borderRadius: '4px',
                        padding: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: '56px'
                    }}>
                    <Box style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                        <InsertDriveFileIcon style={{ color: '#757575', fontSize: '24px' }} />
                        <Typography
                            variant="body2"
                            style={{
                                marginLeft: '16px',
                                color: fileName ? '#000000de' : '#9e9e9e',
                                fontSize: '14px'
                            }}>
                            {fileName || label}
                        </Typography>
                    </Box>
                    <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {fileName && (
                            <Tooltip title="Eliminar archivo">
                                <IconButton
                                    size="small"
                                    onClick={onClear}
                                    style={{ padding: '6px' }}>
                                    <ClearIcon style={{ fontSize: '20px' }} />
                                </IconButton>
                            </Tooltip>
                        )}
                        <input
                            accept="application/pdf,.pdf"
                            style={{ display: 'none' }}
                            id={inputId}
                            type="file"
                            onChange={onChange}
                        />
                        <label htmlFor={inputId} style={{ height: '100%', display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                            <Button
                                variant="contained"
                                color='primary'
                                size='large'
                                component="span">
                                Seleccionar
                            </Button>
                        </label>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default FileUpload;
